import { SubSink } from 'subsink';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, useAnimation, transition } from '@angular/animations';

import { fadeInAnimation } from '@monorepo/ui';
import { StateType } from '@monorepo/ui';

import { LoadingType } from '@monorepo/ui';
import { ALOGLIA_CONFIG } from '../../../shared/constants';
import { SearchParameters } from 'angular-instantsearch/instantsearch/instantsearch';

enum PageState {
  LOADING,
  LOADED,
  NO_LISTING,
}
@Component({
  selector: 'signgaze-listing-container',
  templateUrl: './listing-container.component.html',
  styleUrls: ['./listing-container.component.scss'],
  animations: [
    trigger('fadeIn', [transition(':enter', useAnimation(fadeInAnimation))]),
  ],
})
export class ListingContainerComponent implements OnInit, OnDestroy {
  readonly subs = new SubSink();
  readonly alogliaConfig: any = {
    ...ALOGLIA_CONFIG,
  };
  readonly defaultSearchParameters: SearchParameters = {
    hitsPerPage: 12,
    clickAnalytics: true,
    filters: 'status:APPROVED',
    optionalFilters: ['isScreenAvailableForBooking:true'],
  };

  StateTypeEnum: any = StateType;
  LoadingTypeEnum: any = LoadingType;
  pageStateEnum: any = PageState;
  toggleModalVisibility = false;
  pageState: PageState = this.pageStateEnum.LOADING;
  searchParameters: any = {
    ...this.defaultSearchParameters,
  };
  facetCategory: string;
  facetValue: string;
  isCheckedMap = false;
  isShowMap = false;

  ngOnInit(): void {
    this.listingsInitialLoader();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public listingsInitialLoader(): void {
    setTimeout(() => {
      this.pageState = PageState.LOADED;
    }, 500);
  }

  public isShowFilter(): void {
    this.toggleModalVisibility = !this.toggleModalVisibility;
  }

  public updateStatusById(isChecked: boolean): void {
    this.isCheckedMap = isChecked;
  }
}
